import { render, staticRenderFns } from "./delete-action-cell.vue?vue&type=template&id=a1a45238&scoped=true"
import script from "./delete-action-cell.vue?vue&type=script&lang=ts"
export * from "./delete-action-cell.vue?vue&type=script&lang=ts"
import style0 from "./delete-action-cell.vue?vue&type=style&index=0&id=a1a45238&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a45238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1a45238')) {
      api.createRecord('a1a45238', component.options)
    } else {
      api.reload('a1a45238', component.options)
    }
    module.hot.accept("./delete-action-cell.vue?vue&type=template&id=a1a45238&scoped=true", function () {
      api.rerender('a1a45238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/table-cells/delete-action-cell.vue"
export default component.exports